export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  summary: string;
  content: string;
  date: string;
  author: string;
  imageQuery: string;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '蜜芽APP全新版本上线——这些功能你一定要知道',
    slug: 'miya-app-new-version-2026',
    category: 'zui-xin-dong-tai',
    summary: '蜜芽APP 2026年最新版本正式上线，新增智能客服、订单实时追踪、社群互动等多项实用功能，全面提升用户体验。',
    content: `蜜芽APP全新版本已于近日正式上线，本次更新围绕用户核心需求进行了一系列优化。

首先是智能客服系统的全面升级。新版APP内置了AI智能客服，能够7×24小时在线解答用户的常见问题，涵盖订单查询、物流追踪、退换货流程等方面。用户只需在APP首页点击"在线客服"图标，即可快速获得帮助。

其次是订单实时追踪功能的完善。新版本接入了主流快递公司的数据接口，用户可以在订单详情页查看包裹的实时物流信息，系统还会通过推送通知提醒用户包裹的最新动态。

社群互动功能也得到了大幅增强。用户可以在蜜芽社区中分享购物心得、发布母婴知识、参与话题讨论，与其他宝妈宝爸交流育儿经验。

此外，新版本还优化了页面加载速度，减少了不必要的权限请求，提升了整体使用流畅度。蜜芽团队表示，将继续倾听用户反馈，持续优化产品体验。`,
    date: '2026-08-05',
    author: '蜜芽官方',
    imageQuery: 'A modern smartphone displaying a colorful shopping app interface with warm ambient lighting, minimalist flat lay composition with soft pink and cream tones, clean product photography style, gentle natural light from window, elegant lifestyle aesthetic with subtle feminine touches',
  },
  {
    id: '2',
    title: '蜜芽官方客服联系方式全攻略（2026最新版）',
    slug: 'miya-customer-service-guide-2026',
    category: 'ke-fu-zhi-nan',
    summary: '汇总蜜芽全部官方客服渠道，包括在线客服、电话热线、邮件支持及社交媒体账号，确保您随时能找到蜜芽。',
    content: `想要联系蜜芽客服？本文为您整理了2026年最新的全部官方联系方式。

一、在线客服（推荐）
打开蜜芽APP，点击"我的"→"在线客服"，即可与客服人员实时沟通。服务时间：每日9:00-22:00。在线客服支持文字、图片、订单截图等多种沟通方式，处理效率最高。

二、电话客服
蜜芽全国统一客服热线：400-xxx-xxxx
服务时间：周一至周日 9:00-21:00
建议在拨打电话前准备好您的订单号，以便客服人员快速为您查询。

三、邮件支持
您也可以发送邮件至官方客服邮箱：service@miya.com
邮件中请注明您的账户信息、问题描述及相关订单号，客服团队将在24小时内回复。

四、社交媒体
关注蜜芽官方微信公众号"蜜芽Miya"，通过公众号菜单栏可以进入在线客服系统，同时获取最新促销活动信息。
微博搜索"蜜芽官方微博"，私信留言也可获得客服支持。

五、常见问题自助解决
在联系客服之前，建议您先查看APP内的"帮助中心"，大量常见问题已有详细解答，可以帮您快速解决问题而不必等待客服响应。`,
    date: '2026-07-28',
    author: '蜜芽客服团队',
    imageQuery: 'A warm-toned customer service workspace setup with a laptop showing support chat interface, phone and headset on a clean desk, soft natural lighting through sheer curtains, minimalist and professional atmosphere, gentle pink and cream color palette, cozy and trustworthy brand aesthetic',
  },
  {
    id: '3',
    title: '蜜芽订单物流查询方法——三步搞定',
    slug: 'miya-order-tracking-guide',
    category: 'ding-dan-cha-xun',
    summary: '详细图解蜜芽订单物流查询的三种方式，帮助您快速掌握包裹动态，再也不用担心找不到订单信息。',
    content: `在蜜芽下单后，如何快速查看订单状态和物流信息？本文为您详细介绍三种查询方法。

方法一：APP内直接查询
打开蜜芽APP，进入"我的"→"我的订单"，找到需要查询的订单，点击"查看物流"即可看到详细的物流轨迹。如果订单已发货，系统会显示快递公司、快递单号以及每个物流节点的详细信息。

方法二：网页端查询
访问蜜芽官网，登录您的账户后进入"订单中心"，操作方法同APP一致。网页端查看物流信息时，页面布局更加宽敞，适合在电脑上仔细核对物流详情。

方法三：快递公司官网查询
在蜜芽APP中复制您的快递单号后，可以前往对应快递公司（如顺丰、圆通、中通、韵达等）的官方网站或小程序进行查询，获取最原始的物流数据。

常见问题：
Q：为什么下单后看不到物流信息？
A：订单付款后，仓库需要1-2个工作日进行备货和发货操作。如果超过2个工作日仍未显示物流信息，请联系客服查询。

Q：物流信息长时间不更新怎么办？
A：可能是快递公司系统延迟或包裹在运输途中暂未扫描。建议等待1-2天，如果仍无更新，请联系蜜芽客服协助处理。

Q：收到的商品有问题如何申请售后？
A：在订单详情页点击"申请售后"，根据提示选择退货或换货，填写原因并上传相关照片即可提交售后申请。`,
    date: '2026-07-20',
    author: '蜜芽官方',
    imageQuery: 'A smartphone screen displaying a package tracking interface with delivery route map, placed on a clean wooden desk with a cup of tea nearby, warm natural morning light, minimalist lifestyle composition, soft beige and cream tones, calm and organized atmosphere, product photography style',
  },
  {
    id: '4',
    title: '蜜芽官方社群渠道大汇总——加入我们永不掉队',
    slug: 'miya-official-community-channels',
    category: 'she-qun-dong-tai',
    summary: '一次性告诉你蜜芽所有官方社群入口，包括微信群、QQ群、小红书、抖音等，确保你不错过任何福利信息。',
    content: `蜜芽拥有丰富的社群矩阵，覆盖多种社交平台。加入官方社群，您将第一时间获取促销信息、参与专属活动、与其他宝妈交流育儿心得。

官方微信群
搜索微信号"miya_official"或扫描蜜芽APP内的社群二维码，添加蜜芽小助手为好友，小助手会邀请您加入对应的官方微信群。群内每日分享优惠信息、育儿知识和用户福利。

官方QQ群
蜜芽官方QQ群号：8xxxxxxx（请前往蜜芽APP社群页面获取最新群号）
QQ群适合深度交流，群文件区会定期上传育儿资料和活动信息。

小红书官方账号
在小红书搜索"蜜芽Miya"，关注官方账号获取好物推荐、开箱测评和优惠攻略。蜜芽小红书账号每周更新3-4篇高质量内容，涵盖母婴好物、家庭生活、护肤美妆等多个品类。

抖音官方账号
在抖音搜索"蜜芽"，观看官方直播和短视频内容。蜜芽抖音直播间经常有专属福利价商品，关注账号还可参与评论抽奖活动。

微博官方账号
微博搜索"蜜芽官方微博"，第一时间获取平台公告和活动信息，还可以通过私信联系客服。

社群福利：
加入任意官方社群均可享受新人专享优惠券、社群专属秒杀活动以及不定期的抽奖福利。蜜芽社群致力于打造一个温暖、互助的母婴消费社区。`,
    date: '2026-07-15',
    author: '蜜芽社群运营',
    imageQuery: 'A diverse group of smartphones and tablets displaying various social media app icons on their screens, arranged on a warm cream-colored surface, soft diffused lighting creating gentle shadows, modern community connection concept, clean and aspirational lifestyle aesthetic, pastel pink and warm beige tones, editorial flat lay photography',
  },
  {
    id: '5',
    title: '蜜芽8月会员日——全场满减叠加优惠券攻略',
    slug: 'miya-august-member-day-sale',
    category: 'cu-xiao-huo-dong',
    summary: '蜜芽8月会员日即将开启，全场满299减50叠加专属优惠券，还有限时秒杀和新人福利，手把手教你如何买到最划算。',
    content: `蜜芽8月会员日促销活动将于8月15日正式启动，持续至8月20日。本次活动的优惠力度空前，以下为您详细解读活动规则和购买攻略。

活动一：全场满减
活动期间，全场商品满299元减50元，满599元减120元，满999元减250元。满减优惠自动计算，无需领券。

活动二：会员专属优惠券
蜜芽会员可在活动页面领取专属优惠券：全场通用20元券（满199可用）、母婴专享50元券（满399可用）、美妆专享30元券（满299可用）。优惠券可与满减活动叠加使用。

活动三：限时秒杀
每日10:00、14:00、20:00三个时段开启限时秒杀，精选爆款商品低至5折，数量有限，先到先得。

活动四：新人福利
新注册用户首单额外享受9折优惠，还可领取价值100元的新人礼包（含多张优惠券）。

购买攻略：
1. 提前将心仪商品加入购物车，活动开始后直接结算。
2. 优先使用满减叠加优惠券的组合方式，最大化优惠力度。
3. 关注秒杀时段，热门商品建议提前1分钟进入页面刷新。
4. 使用蜜芽支付还可享受随机立减优惠，最高减99元。

注意事项：
- 满减和优惠券使用规则以活动页面为准
- 秒杀商品不支持退换货（质量问题除外）
- 如有疑问请联系在线客服`,
    date: '2026-08-08',
    author: '蜜芽活动运营',
    imageQuery: 'A vibrant shopping promotion flat lay with gift boxes, discount tags, and shopping bags in soft pastel pink and gold tones, elegant and festive composition, warm ambient lighting with gentle sparkle accents, luxury retail aesthetic, clean and celebratory atmosphere, modern e-commerce lifestyle photography',
  },
  {
    id: '6',
    title: '蜜芽退换货政策详解——售后无忧指南',
    slug: 'miya-return-policy-guide',
    category: 'ding-dan-cha-xun',
    summary: '全面解读蜜芽退换货政策，包括退换货条件、流程步骤、运费承担规则及常见问题解答，让您购物无忧。',
    content: `在蜜芽购物后如果对商品不满意，如何申请退换货？本文为您详细解读蜜芽的售后政策。

一、退换货条件
蜜芽支持7天无理由退货。自签收之日起7天内，商品保持原状（未使用、未拆封、配件齐全、包装完整）即可申请退货。以下商品不支持无理由退货：食品、保健品、个人护理用品、内衣内裤等涉及卫生安全的品类，以及已明确标注"不支持七天无理由退货"的商品。

对于存在质量问题的商品，蜜芽支持15天内换货或退货，运费由蜜芽承担。

二、退换货流程
步骤1：打开蜜芽APP，进入"我的"→"我的订单"，找到需要售后的订单。
步骤2：点击"申请售后"，选择"退货退款"或"换货"。
步骤3：填写退货原因，上传商品照片作为凭证。
步骤4：提交申请后，客服将在24小时内审核。
步骤5：审核通过后，按照系统提示将商品寄回指定地址。
步骤6：仓库签收退货后，退款将在3-5个工作日内原路返回。

三、运费规则
- 7天无理由退货：退回运费由买家承担
- 商品质量问题退货/换货：来回运费由蜜芽承担
- 换货重发：运费由蜜芽承担

四、退款时效
退货签收后，退款通常3-5个工作日到账。如超过7个工作日仍未收到退款，请联系客服查询。`,
    date: '2026-07-10',
    author: '蜜芽售后团队',
    imageQuery: 'A clean and organized desk setup with a return package and shipping label ready to be sent, surrounded by packing materials and tape dispenser, soft window light creating a calm atmosphere, minimalist e-commerce logistics concept, warm beige and cream tones, trustworthy and reassuring brand aesthetic, editorial product photography',
  },
  {
    id: '7',
    title: '蜜芽账户安全指南——保护您的账户和资金',
    slug: 'miya-account-security-guide',
    category: 'ke-fu-zhi-nan',
    summary: '如何保障您的蜜芽账户安全？本文从密码管理、支付安全、防诈骗提醒等方面为您提供全面的账户保护建议。',
    content: `账户安全是网购体验的基础保障。以下为您整理蜜芽账户的安全使用指南。

一、密码管理
建议使用包含大小写字母、数字和特殊符号的强密码，长度不少于8位。不要在多个平台使用相同的密码。建议每3个月更换一次密码。

二、支付安全
蜜芽支持微信支付、支付宝、银行卡等多种支付方式。建议开启支付密码或指纹/面容验证功能。每次支付前请确认订单金额和商品信息，避免误操作。

三、防诈骗提醒
近期有不法分子冒充蜜芽客服进行诈骗活动，请务必注意：
- 蜜芽客服不会主动索要您的支付密码、验证码或银行卡信息
- 蜜芽的退款会原路返回，不会要求您提供银行卡号
- 如有自称蜜芽客服的人员联系您，请先通过APP内官方渠道核实

四、设备管理
定期检查账户的登录设备列表，如发现异常设备登录，请立即修改密码并联系客服。避免在公共WiFi环境下进行支付操作。

五、异常处理
如果发现账户出现异常订单或资金变动，请立即：
1. 修改登录密码和支付密码
2. 联系蜜芽客服冻结账户
3. 检查关联的支付账户安全`,
    date: '2026-07-05',
    author: '蜜芽安全团队',
    imageQuery: 'A smartphone displaying a security lock icon on screen, placed on a clean light-colored desk surface, soft natural side lighting creating gentle shadows, minimalist cybersecurity concept with warm tones, calm and secure atmosphere, cream and soft gray color palette, modern editorial style photography',
  },
  {
    id: '8',
    title: '蜜芽社群福利活动——8月亲子嘉年华报名开启',
    slug: 'miya-community-family-carnival-august',
    category: 'she-qun-dong-tai',
    summary: '蜜芽线下亲子嘉年华活动将于8月下旬在北京、上海、广州三地同步举办，社群成员可优先报名并享受专属礼品。',
    content: `蜜芽首届线下亲子嘉年华将于2026年8月26日至27日在北京、上海、广州三座城市同步举办！

活动亮点：
1. 知名育儿专家现场讲座——邀请三甲医院儿科医生和育儿博主分享科学育儿知识
2. 亲子互动游戏区——丰富的亲子游戏和手工DIY活动，增进亲子关系
3. 品牌体验区——现场体验蜜芽精选母婴好物，享受专属活动价
4. 社群见面会——与蜜芽社群管理员和其他宝妈面对面交流

报名方式：
蜜芽社群成员可通过社群内发布的报名链接优先报名，名额有限，先到先得。非社群成员可关注蜜芽APP首页的活动入口进行报名。

活动福利：
- 到场即送蜜芽定制礼品一份
- 现场下单享额外9折优惠
- 参与互动游戏赢取丰富奖品

活动地点：
- 北京：朝阳区xxx国际会展中心
- 上海：浦东新区xxx博览中心
- 广州：天河区xxx创意园

温馨提示：活动期间请照顾好您的小朋友，注意现场安全指引。如有任何疑问，请联系所在城市的社群管理员。`,
    date: '2026-08-02',
    author: '蜜芽社群运营',
    imageQuery: 'A bright and cheerful family carnival scene with colorful balloons and activity booths in a modern indoor venue, families with children enjoying various games and workshops, warm natural light flooding through large windows, joyful and lively atmosphere, soft pastel pink and cream color scheme, editorial event photography with cinematic warmth',
  },
  {
    id: '9',
    title: '蜜芽支付方式全解析——哪种最适合你',
    slug: 'miya-payment-methods-guide',
    category: 'ke-fu-zhi-nan',
    summary: '蜜芽支持微信支付、支付宝、银行卡、蜜芽余额等多种支付方式，本文帮您分析各支付方式的优劣和使用技巧。',
    content: `蜜芽平台支持多种支付方式，满足不同用户的需求。以下是各支付方式的详细介绍。

微信支付：便捷首选
绑定微信后无需跳转即可完成支付，支持指纹和面容验证，安全高效。微信支付还经常有随机立减活动。

支付宝：稳定可靠
支付宝支付流程成熟稳定，支持花呗分期（部分商品），适合需要分期的用户。支付宝也常有满减优惠活动。

银行卡支付：大额首选
支持储蓄卡和信用卡支付。部分银行信用卡在蜜芽消费可享受积分和返现优惠。

蜜芽余额：优惠最多
充值蜜芽余额常可获得额外赠送，使用余额支付还可享受会员专属折扣。建议经常在蜜芽购物的用户适当充值。

支付小贴士：
- 小额订单建议使用微信支付或支付宝，方便快捷
- 大额订单建议使用信用卡支付，享受银行积分
- 关注支付页面的优惠提示，有时会有隐藏的支付优惠
- 开启支付验证功能，保障资金安全`,
    date: '2026-06-28',
    author: '蜜芽官方',
    imageQuery: 'A flat lay of various payment methods represented by smartphone screens showing payment interfaces, next to a wallet and credit cards, warm soft lighting, clean minimalist composition, modern fintech concept, cream and soft rose gold tones, sophisticated e-commerce aesthetic, editorial product photography',
  },
  {
    id: '10',
    title: '蜜芽会员体系全新升级——更多权益等你解锁',
    slug: 'miya-membership-upgrade-2026',
    category: 'zui-xin-dong-tai',
    summary: '蜜芽会员体系2026年全面升级，新增钻石会员等级，各等级权益大幅提升，更有多项专属福利等待会员体验。',
    content: `蜜芽会员体系于2026年7月完成全面升级，新版会员体系分为四个等级：普通会员、银卡会员、金卡会员和全新的钻石会员。

普通会员：注册即享
- 享受平台基础优惠
- 参与限时秒杀活动
- 访问帮助中心

银卡会员：年度消费满500元或一次性充值300元
- 享受全场9.8折优惠
- 每月1张10元优惠券
- 优先参与社群活动
- 专属客服通道

金卡会员：年度消费满2000元或一次性充值1000元
- 享受全场9.5折优惠
- 每月2张20元优惠券
- 免费参与线下活动
- 生日当月双倍积分
- 优先发货权益

钻石会员（新增）：年度消费满5000元
- 享受全场9折优惠
- 每月4张30元优惠券
- 免费参与所有线下活动
- 专属一对一客服
- 新品优先体验权
- 每年2次免费退换货
- 生日当月赠送精美礼品

如何升级会员？
打开蜜芽APP → "我的" → "会员中心"，即可查看当前会员等级和升级条件。满足消费金额后，系统自动升级，无需手动操作。`,
    date: '2026-07-01',
    author: '蜜芽官方',
    imageQuery: 'A elegant membership card display on a soft pink gradient background, with gold accents and premium card designs layered beautifully, warm diffused lighting creating a luxurious atmosphere, modern brand loyalty concept, cream and rose gold tones, sophisticated retail aesthetic, high-end editorial photography style',
  },
  {
    id: '11',
    title: '蜜芽2026年战略升级——打造一站式母婴消费平台',
    slug: 'miya-2026-strategic-upgrade',
    category: 'zui-xin-dong-tai',
    summary: '蜜芽发布2026年战略升级计划，将从母婴电商平台向一站式母婴消费服务平台转型，涵盖购物、知识、社群、服务四大板块。',
    content: `蜜芽于近日发布了2026年战略升级计划，宣布将从传统的母婴电商平台转型为一站式母婴消费服务平台。

新的战略布局包括四大核心板块：

购物板块：持续优化商品品质和品类丰富度，引入更多国际品牌和国货精品，满足不同层次消费者的需求。同时升级物流体系，实现核心城市次日达。

知识板块：打造蜜芽育儿知识库，邀请儿科医生、营养师、早教专家入驻平台，提供科学的育儿指导。推出系列音频课程和视频教学内容。

社群板块：强化蜜芽社群功能，建设更紧密的用户社区。通过线上社群+线下活动的模式，打造覆盖全国主要城市的宝妈互助网络。

服务板块：新增产后康复、亲子摄影、儿童保险等本地生活服务推荐，帮助用户一站式解决育儿过程中的各类需求。

蜜芽创始人表示："我们的目标不仅是卖好商品，更是陪伴每一位妈妈和宝宝健康成长。2026年，蜜芽永不失联，我们将以更全面的服务回馈用户。"

此次战略升级预计将在一年内分阶段完成，用户将在APP中逐步感受到变化。`,
    date: '2026-06-20',
    author: '蜜芽官方',
    imageQuery: 'A modern open-plan office space with a large screen displaying strategic growth charts and future vision graphics, team of diverse professionals collaborating at a meeting table, warm natural light through floor-to-ceiling windows, soft beige and cream interior design, forward-thinking corporate atmosphere, clean and aspirational editorial photography',
  },
  {
    id: '12',
    title: '蜜芽礼品卡使用指南——送人自用两相宜',
    slug: 'miya-gift-card-guide',
    category: 'cu-xiao-huo-dong',
    summary: '蜜芽礼品卡上线啦！面额灵活选择，支持个性化定制封面和祝福语，适合送给新手妈妈的最佳礼物。',
    content: `蜜芽全新推出礼品卡功能，是送给新手妈妈、准妈妈的绝佳选择。

礼品卡面额
支持50元、100元、200元、500元、1000元五种面额选择，有效期自购买之日起12个月。

如何使用礼品卡
在结算页面选择"蜜芽礼品卡"作为支付方式，输入卡号和密码即可抵扣。礼品卡可与优惠券叠加使用，但不支持与其他礼品卡合并使用。

个性化定制
购买礼品卡时可选择多种精美封面模板（母婴主题、童趣主题、温馨主题等），并添加个性化祝福语（限50字以内）。定制礼品卡通过微信发送给好友，对方点击即可领取。

购买渠道
打开蜜芽APP → "我的" → "礼品卡" → "购买礼品卡"，选择面额和封面，填写祝福语后付款即可。

使用规则
- 礼品卡不记名、不挂失、不兑现
- 单笔订单仅限使用一张礼品卡
- 礼品卡余额不设找零
- 如使用礼品卡支付的订单发生退款，退款金额将退回原礼品卡`,
    date: '2026-06-15',
    author: '蜜芽官方',
    imageQuery: 'A beautifully wrapped gift box with elegant ribbon and a decorative gift card placed on top, soft pastel pink background with subtle floral elements, warm diffused lighting from above, luxurious gift-giving concept, cream and rose gold tones, sophisticated retail aesthetic, editorial product photography with romantic atmosphere',
  },
];

export const getArticleBySlug = (slug: string) => articles.find((a) => a.slug === slug);

export const getArticlesByCategory = (categorySlug: string) =>
  articles.filter((a) => a.category === categorySlug);

export const getLatestArticles = (count: number) =>
  [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, count);